import { render, staticRenderFns } from "./AgnetAssign.vue?vue&type=template&id=b93def9a&"
import script from "./AgnetAssign.vue?vue&type=script&lang=js&"
export * from "./AgnetAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports